// CourseGrammar.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./CourseGrammar.css";
import logo from "./bluelogo.png";
// videos
import grammarVideo1 from "./CourseContainer/Grammar/Gerund and infinitive 2bac(1080P_HD).mp4";
import grammarVideo14 from "./CourseContainer/Grammar/Reported speech part 1(1080P_HD).mp4";
import grammarVideo15 from "./CourseContainer/Grammar/Reported speech part2(1080P_HD).mp4";
import grammarVideo16 from "./CourseContainer/Grammar/Reported speech part 3(1080P_HD).mp4";
import grammarVideo2 from "./CourseContainer/Grammar/Unit 2_ modal verbs part 1 2bac - أبسط شرح على اليوتيب(1080P_HD).mp4";
import grammarVideo3 from "./CourseContainer/Grammar/modal verbs part2(1080P_HD).mp4";
import grammarVideo4 from "./CourseContainer/Grammar/أبسط شرح على اليوتيب _Modal verbs in English part 3(1080P_HD).mp4";
import grammarVideo5 from "./CourseContainer/Grammar/simple modals exercises 2025(1080P_HD).mp4";
import grammarVideo6 from "./CourseContainer/Grammar/perfect modals(1080P_HD).mp4";
import grammarVideo12 from "./CourseContainer/Grammar/Expressing purpose without mistakes(1080P_HD) (1).mp4";
import grammarVideo13 from "./CourseContainer/Grammar/Expressing purpose Exercises without mistakes(1080P_HD) (1).mp4";
import grammarVideo8 from "./CourseContainer/Grammar/Passive voice(1080P_HD).mp4";
import grammarVideo10 from "./CourseContainer/Grammar/wish and if only(1080P_HD).mp4";
import grammarVideo7 from "./CourseContainer/Grammar/relative pronouns 2026 PROOOOO(1080P_HD).mp4";
import grammarVideo9 from "./CourseContainer/Grammar/conditional type 3(1080P_HD).mp4";
import grammarVideo11 from "./CourseContainer/Grammar/Expressing regret(1080P_HD).mp4";
import grammarVideo17 from "./CourseContainer/Grammar/Prefixes and suffixes(1080P_HD).mp4";
import grammarVideo18 from "./CourseContainer/Grammar/phrasal verbs 2026 pro(1080P_HD).mp4";
import grammarVideo19 from "./CourseContainer/Grammar/National grammar exam 1(1080P_HD).mp4";

import GrammarIntro from "./CourseContainer/Grammar/intro to grammar.mp4";

// pdfs
import grammarVideo1Pdf from "./CourseContainer/pdfs/Grammar/gerund and infinitive.pdf";
import grammarVideo5Pdf from "./CourseContainer/pdfs/Grammar/simple modals.pdf";
import grammarVideo6Pdf from "./CourseContainer/pdfs/Grammar/perfect modals.pdf";
// import grammarVideo12Pdf from './CourseContainer/pdfs/Grammar/expressing purpose 2026(1080P_HD).pdf'
import grammarVideo13Pdf from "./CourseContainer/pdfs/Grammar/Expresing purpose.pdf";
import grammarVideo8Pdf from "./CourseContainer/pdfs/Grammar/passive voice.pdf";
import grammarVideo10Pdf from "./CourseContainer/pdfs/Grammar/wish and if only.pdf";
import grammarVideo7Pdf from "./CourseContainer/pdfs/Grammar/relative pronouns.pdf";
import grammarVideo9Pdf from "./CourseContainer/pdfs/Grammar/conditionals.pdf";
// import grammarVideo11Pdf from './CourseContainer/pdfs/Grammar/expressing regret.pdf'
import grammarVideo12Pdf from "./CourseContainer/pdfs/Grammar/Prefixes and suffixes.pdf";
import grammarVideo14Pdf from "./CourseContainer/pdfs/Grammar/phrasal verbs.pdf";
// import grammarVideo19Pdf from './CourseContainer/pdfs/Grammar/National grammar exam 1(1080P_HD).pdf'

import grammarVideo11Pdf from "./CourseContainer/pdfs/Grammar/reported speech.pdf";

import Footer from "./Footer";
import Header from "./Header";

export default function CourseGrammar() {
  // const tabs = ["Gerund & Infinitive", "Modal Verbs", "Passive Voice", ">>>"];
  const [activeTab, setActiveTab] = useState("Exams");
  const [query, setQuery] = useState("");

  // which accordion cards are open
  const [openIds, setOpenIds] = useState(() => new Set());

  // only one inline video open at a time
  const [openInlineVideo, setOpenInlineVideo] = useState(null); // { lessonId, itemId, videoSrc, title, subtitle }

  const lessons = useMemo(
    () => [
      {
        id: "introduction-to-Grammar",
        title: "Introduction",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gintro-p1",
            label: "Click Play >>",
            duration: "01:44 min",
            videoSrc: GrammarIntro,
          },
        ],
      },
      {
        id: "Gerund-and-Infinitive",
        title: "Gerund and Infinitive",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gerund1-p1",
            label: "Lesson",
            duration: "13:16 min",
            videoSrc: grammarVideo1,
          },

          // {
          //   id: "gps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo1Pdf,
          // },
        ],
      },
      {
        id: "simple_modals",
        title: "Modal Verbs",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gad-p1",
            label: "Part 1",
            duration: "10:06 min",
            videoSrc: grammarVideo2,
          },
          {
            id: "gad-p2",
            label: "Part 2",
            duration: "11:42 min",
            videoSrc: grammarVideo3,
          },
          {
            id: "gad-p3",
            label: "Part 3",
            duration: "09:45 min",
            videoSrc: grammarVideo4,
          },

          {
            id: "gad-p4",
            label: "exercise",
            duration: "10:04 min",
            videoSrc: grammarVideo5,
          },

          // {
          //   id: "gps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo5Pdf,
          // },
        ],
      },
      {
        id: "PerfectModal",
        title: "Perfect Modals",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gaa-p1",
            label: "Lesson",
            duration: "07:35 min",
            videoSrc: grammarVideo6,
          },

          // {
          //   id: "gps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo6Pdf,
          // },
        ],
      },
      {
        id: "Relative-Pronouns",
        title: "Relative Pronouns",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gac-p1",
            label: "Lesson",
            duration: "14:53 min",
            videoSrc: grammarVideo7,
          },

          // {
          //   id: "gps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo7Pdf,
          // },
        ],
      },
      {
        id: "PassiveVoice",
        title: "Passive Voice",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gco-p1",
            label: "Lesson",
            duration: "15:12 min",
            videoSrc: grammarVideo8,
          },

          // {
          //   id: "gps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo8Pdf,
          // },
        ],
      },
      {
        id: "Conditionals",
        title: "Conditional Type 3",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "guec-p1",
            label: "Lesson",
            duration: "15:30 min",
            videoSrc: grammarVideo9,
          },

          // {
          //   id: "gups-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo9Pdf,
          // },
        ],
      },
      {
        id: "Wish-and-If-only",
        title: "Wish and If only",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "guar-p1",
            label: "Lesson",
            duration: "13:51 min",
            videoSrc: grammarVideo10,
          },

          // {
          //   id: "yups-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo10Pdf,
          // },
        ],
      },
      {
        id: "ExressingRegret",
        title: "Exressing Regret",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gymr-p1",
            label: "Lesson",
            duration: "04:39 min",
            videoSrc: grammarVideo11,
          },

          // {
          //   id: "gyps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   pdfSrc: grammarVideo11Pdf,
          // },
        ],
      },
      {
        id: "Expressing-Purpose",
        title: "Expressing Purpose",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gumsu-p1",
            label: "Lesson",
            duration: "12:30 min",
            videoSrc: grammarVideo12,
          },
          {
            id: "gumsu-p2",
            label: "Exercise",
            duration: "06:50 min",
            videoSrc: grammarVideo13,
          },

          // {
          //   id: "ygps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo13Pdf,
          // },
        ],
      },
      {
        id: "Reported-speech",
        title: "Reported Speech",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gres-p1",
            label: "Lesson",
            duration: "20:32 min",
            videoSrc: grammarVideo14,
          },
          {
            id: "gres-p2",
            label: "Lesson",
            duration: "18:19 min",
            videoSrc: grammarVideo15,
          },
          {
            id: "gres-p3",
            label: "Lesson",
            duration: "14:16 min",
            videoSrc: grammarVideo16,
          },

          // {
          //   id: "ps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo11Pdf,
          // },
        ],
      },
      {
        id: "PrefixesSuffixes",
        title: "Prefixes and Suffixes",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gted-p1",
            label: "Lesson",
            duration: "02:40 min",
            videoSrc: grammarVideo17,
          },

          // {
          //   id: "ps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo12Pdf,
          // },
        ],
      },
      {
        id: "PhrasalVerbs",
        title: "Phrasal Verbs",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gyfed-p1",
            label: "Lesson",
            duration: "11:22 min",
            videoSrc: grammarVideo18,
          },

          // {
          //   id: "fps-pdf",
          //   label: "Exercise + Summary",
          //   kind: "exercise",
          //   // pdfSrc: grammarVideo14Pdf,
          // },
        ],
      },

      {
        id: "NationalExam",
        title: "National Exam",
        // subtitle: "Practice",
        // meta: ["1 lesson", "8 min"],
        items: [
          {
            id: "mf1-lesson",
            label: "Watch Correction",
            kind: "Lesson",
            duration: "20:07 min",
            videoSrc: grammarVideo19,
          },
          {
            id: "gymf1-pdf",
            label: "Download Exercises",
            kind: "exercise",
            
            // pdfSrc: grammarVideo19Pdf,
          },
        ],
      },
    ],
    []
  );

  const filteredLessons = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return lessons;
    return lessons.filter((l) =>
      `${l.title} ${l.subtitle}`.toLowerCase().includes(q)
    );
  }, [lessons, query]);

  const toggleAccordion = (lessonId) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(lessonId)) next.delete(lessonId);
      else next.add(lessonId);
      return next;
    });
  };

  const toggleInlineVideo = ({
    lessonId,
    itemId,
    videoSrc,
    title,
    subtitle,
  }) => {
    setOpenInlineVideo((curr) => {
      if (curr && curr.lessonId === lessonId && curr.itemId === itemId)
        return null;
      return { lessonId, itemId, videoSrc, title, subtitle };
    });
  };

  // icons defined INSIDE this file (simple)
  const IconPlay = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#4b5563" />
    </svg>
  );

  const IconPlaySmall = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#6b7280" />
    </svg>
  );

  const IconChevronDown = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M7 10l5 5 5-5H7Z" fill="#6b7280" />
    </svg>
  );

  const IconCheck = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.2 16.2 5.5 12.5 4.1 13.9l5.1 5.1L20 8.2 18.6 6.8 9.2 16.2Z"
        fill="#16a34a"
      />
    </svg>
  );
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  window.onscroll = function () {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");

    if (window.scrollY > 50) {
      headerLogo.style.width = "60px";

      header.style.transition = "background 0.3s ease-in-out";
    } else {
      if (window.innerWidth < "668") {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      } else {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      }
    }
  };
  useEffect(() => {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");
    headerLogo.style.width = "60px";
    header.style.background = "white";
  }, []);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div className="GrammarContainer">
      <header id="All__courses__header">
        <a href="https://toustousacademy.com/">
          <img className="Grammar__header__img" src={logo} alt="" />
        </a>
        <ul>
          <a href="/" onClick={scrollToTop}>
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      <div className="tp-page">
        <div className="tp-container">
          <header className="tp-header">
            <h1 className="tp-title">Grammar</h1>
            <p className="tp-subtitle">
              Short lessons + practice + correction.
            </p>
          </header>

          <div className="tp-toolbar">
            {/* <div className="tp-tabs">
              {tabs.map((t) => (
                <button
                  key={t}
                  className={`tp-tab ${activeTab === t ? "is-active" : ""}`}
                  onClick={() => setActiveTab(t)}
                  type="button"
                >
                  <span>{t}</span>
                  {t === "Exams" || t === "Future"}
                </button>
              ))}
            </div> */}
          </div>

          <main className="tp-list">
            {filteredLessons.map((lesson) => {
              const isOpen = openIds.has(lesson.id);

              return (
                <article key={lesson.id} className="tp-card">
                  {/* Accordion header */}
                  <button
                    className="tp-accHeader"
                    type="button"
                    onClick={() => toggleAccordion(lesson.id)}
                  >
                    <div className="tp-accLeft">
                      <div className="tp-playCircle" aria-hidden="true">
                        <IconPlay />
                      </div>

                      <div className="tp-cardMain">
                        <div className="tp-cardTitle">{lesson.title}</div>
                        <div className="tp-cardSub">{lesson.subtitle}</div>

                        {lesson.meta && (
                          <div className="tp-pills">
                            {lesson.meta.map((m) => (
                              <span key={m} className="tp-pill">
                                {m}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <span className={`tp-accChev ${isOpen ? "is-open" : ""}`}>
                      <IconChevronDown />
                    </span>
                  </button>

                  {/* Accordion body */}
                  <div className={`tp-accBody ${isOpen ? "is-open" : ""}`}>
                    {lesson.items.map((it) => {
                      const isExercise = it.kind === "exercise";
                      const isThisVideoOpen =
                        openInlineVideo?.lessonId === lesson.id &&
                        openInlineVideo?.itemId === it.id;

                      return (
                        <div key={it.id} className="tp-itemBlock">
                          <div
                            className={`tp-itemRow ${
                              isExercise ? "is-exercise" : ""
                            }`}
                          >
                            <div className="tp-itemLeft">
                              <div
                                className={
                                  isExercise
                                    ? "tp-checkCircle"
                                    : "tp-smallPlayCircle"
                                }
                                aria-hidden="true"
                              >
                                {isExercise ? <IconCheck /> : <IconPlaySmall />}
                              </div>
                              <div className="tp-itemTitle">{it.label}</div>
                            </div>

                            <div className="tp-itemRight">
                              <div className="tp-partDur">
                                {it.duration || ""}
                              </div>

                              {
                              isExercise ? (
                                <a
                                  className="tp-playBtn tp-playBtnLight"
                                  href={it.pdfSrc}
                                  download
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Download PDF
                                  <span className="tp-playBtnChev">›</span>
                                </a>
                              ) : 
                              (
                                <button
                                  className="tp-playBtn"
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleInlineVideo({
                                      lessonId: lesson.id,
                                      itemId: it.id,
                                      videoSrc: it.videoSrc,
                                      title:
                                        it.label === "Click Play >>"
                                          ? lesson.title
                                          : `${lesson.title} — ${it.label}`,
                                      subtitle: lesson.subtitle,
                                    });
                                  }}
                                >
                                  {isThisVideoOpen ? "Hide" : "Play"}{" "}
                                  <span className="tp-playBtnChev">›</span>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* inline video under the row */}
                          {isThisVideoOpen && (
                            <div className="tp-inlineVideoWrap">
                              <div className="tp-inlineVideoHeader">
                                <div className="tp-inlineVideoTitle">
                                  {openInlineVideo.title}
                                </div>
                                <div className="tp-inlineVideoSub">
                                  {openInlineVideo.subtitle}
                                </div>
                              </div>

                              <video
                                key={openInlineVideo.videoSrc}
                                className="tp-inlineVideo"
                                controlsList="nodownload noplaybackrate"
                                disablePictureInPicture
                                onContextMenu={(e) => e.preventDefault()}
                                controls
                                autoPlay
                                src={openInlineVideo.videoSrc}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </article>
              );
            })}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
